import Alert from './AlertInstance';
import LocaleReceiver from '../locale-provider/LocaleReceiver';

export default LocaleReceiver('Alert')(Alert);
